import "glightbox/dist/css/glightbox.min.css";

export default () => {
    if (document.querySelector("[data-lightbox]")) {
        import(/* webpackChunkName: "lightbox" */ "glightbox").then(
            ({ default: Lightbox }) =>
                Lightbox({
                    selector: "[data-lightbox]",
                    autoplayVideos: false,
                    plyr: {
                        config: {
                            hideControls: true,
                        },
                    },
                })
        );
    }
};